
import { Tab, Tabs } from 'react-bootstrap'
import CardContenedorAdmin from '../components/CardContenedorAdmin'
import HistorialVacacionesAdmin from './HistorialVacacionesAdmin'
import ListadoEmpleadosAdmin from '../components/ListadoEmpleadosAdmin'
import { useEmpleadoStore } from '../stores/useEmpleadoStore'

export default function VacacionesAdmin() {


    const objLogueado = useEmpleadoStore(state => state.objLogueado)

    if (!objLogueado.permitido) {
        window.location = "/"
        return (<></>)
    }


    return (
        <CardContenedorAdmin ruta='vacaciones'>

            <Tabs
                defaultActiveKey="listado"
                id="uncontrolled-tab-example-1"
                className="mb-3"
                unmountOnExit={true}
                fill
            >
                <Tab eventKey="listado" title="Asignar vacaciones" className='m-3'>
                    <ListadoEmpleadosAdmin/>
                </Tab>
                <Tab eventKey="solicitudes" title="Listado de solicitudes" className='m-3'>
                    <HistorialVacacionesAdmin />
                </Tab>
            </Tabs>

        </CardContenedorAdmin>
    )
}
